import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useHotkeys } from "react-hotkeys-hook";
import {
  Card,
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Grid,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography,
  CircularProgress,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";
import { styles } from "../theme/styles";
import { styled } from "@mui/material/styles";
import { Creators as StoresCreators } from "../store/ducks/stores";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TablePagination from "@mui/material/TablePagination";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import LinearWithValueLabel from "./LinearLabel";
import { parse } from "papaparse";
import Cookies from "js-cookie";
import { verifyToken } from "../helpers/jwtValidation";

const TableForm = (props) => {
  const {
    stores,
    token,
    storeId,
    updateStockStores,
    downloadInventoryByStore,
    loadingStores,
    updateStoreById,
    userData,
  } = props;
  const [initialRows, setInitialRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [modifiedStock, setModifiedStock] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [error, setError] = useState(false);
  const inputFileRef = useRef(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const columnWidth = 100 / 7;
  const [rolEnCookie, setRolEnCookie] = useState();
  const [isButtonEnabledAux, setIsButtonEnabledAux] = useState();
    const navigate = useNavigate();
  useEffect(() => {
    if (Cookies.get("loginCookie")) {
      const loginCookie = Cookies.get("loginCookie");
      const userData = verifyToken(loginCookie).data.data;
      // console.log("cookievalor: ", userData);
      setRolEnCookie(userData);
      if (userData.rol == "STORE") {
        const isMonday = new Date().getDay() === 1;
        const currentHour = new Date().getHours();
        const isInTimeRange = currentHour >= 7 && currentHour < 22;
        const isButtonEnabled = isMonday && isInTimeRange;
        setIsButtonEnabledAux(isButtonEnabled);
      } else if (userData.rol == "ADMIN") {
      }
    }
  }, []);
  useEffect(() => {
    if (stores && Array.isArray(stores) && stores.length > 0) {
      const storeWithIdNumber = stores[0];

      if (
        storeWithIdNumber &&
        Array.isArray(storeWithIdNumber.actualInventory)
      ) {
        setInitialRows(
          storeWithIdNumber.actualInventory.map((item) =>
            createData(
              item.subCategoryName,
              item.description,
              item.subCategoryId,
              item.material,
              item.stock,
              parseFloat(item.price).toFixed(2)
            )
          )
        );
      } else {
      }
    } else {
    }
  }, [stores]);

  useEffect(() => {
    const filtered = initialRows.filter((row) => {
      const {
        subCategoryName,
        description,
        subCategory,
        material,
        stock,
        price,
      } = row;
      const searchValue = searchTerm.toLowerCase();

      return (
        String(subCategoryName.toLowerCase()).includes(searchValue) ||
        String(description.toLowerCase()).includes(searchValue) ||
        String(subCategory).includes(searchValue) ||
        String(material).includes(searchValue) ||
        String(stock).includes(searchValue)
        // ||
        // String(price).includes(searchValue)
      );
    });

    setFilteredRows(filtered);
    setPage(0);
  }, [initialRows, searchTerm]);

  const createData = useMemo(
    () =>
      (subCategoryName, description, subCategory, material, stock, price) => {
        return {
          subCategoryName,
          description,
          subCategory,
          material,
          stock,
          price: parseFloat(price).toFixed(2),
        };
      },
    []
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const rowsToDisplay = filteredRows.slice(startIndex, endIndex);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#00205b",
      color: theme.palette.common.white,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#dcffed",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleSearch = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const handleStockInputChange = (event) => {
    const inputValue = event.target.value;
    if (/^$|^\d+$/.test(inputValue)) {
      setModifiedStock(inputValue);
      setError(false);
    }
  };

  const blockEditByRol = () => {
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();

    if (
      currentDay !== 1 ||
      currentHour > 23 ||
      (currentHour === 23 && currentMinute >= 59)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleStockEdit = (index) => {
    const selectedProduct = rowsToDisplay[index];
    //console.log("selectedProdcut", selectedProduct);
    setSelectedProduct(selectedProduct);
    setModifiedStock(rowsToDisplay[index].stock);
    setSelectedRowIndex(index);
    setOpenDialog(true);
  };

  const handdleOnCloseModal = () => {
    setOpenDialog(false);
    setSelectedRowIndex(null);
    setModifiedStock("");
    setError(false);
  };

  const handleStockSave = async () => {
    if (modifiedStock == null || modifiedStock === "") {
      setError(true);
      return;
    }
    const newStock = { ...selectedProduct, stock: modifiedStock };
    await updateStockStores(token, storeId, newStock);
    setOpenDialog(false);
    setSelectedRowIndex(null);
    setModifiedStock("");
    setError(false);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useHotkeys("up,down", (event, handler) => {
    if (openDialog) {
      if (event.key === "ArrowDown") {
        if (
          selectedRowIndex === rowsToDisplay.length - 1 &&
          page !== filteredRows / page
        ) {
          setPage(page + 1);
          setSelectedRowIndex(0);
        } else {
          setSelectedRowIndex((prevIndex) =>
            prevIndex === null
              ? 0
              : Math.min(prevIndex + 1, rowsToDisplay.length - 1)
          );
        }
      } else if (event.key === "ArrowUp") {
        if (selectedRowIndex === 0 && page !== 0) {
          setPage(page - 1);
          setSelectedRowIndex(rowsToDisplay.length - 1);
          //console.log(rowsToDisplay);
        } else {
          setSelectedRowIndex((prevIndex) =>
            prevIndex === null ? 0 : Math.max(prevIndex - 1, 0)
          );
        }
      }

      if (selectedRowIndex !== null) {
        setModifiedStock(rowsToDisplay[selectedRowIndex].stock);
      }
    }
  });

  const handleStores = (event) => {
    event.preventDefault();

    if (stores && token) {
      downloadInventoryByStore(token, storeId);
    } else {
      console.error("Error ");
    }
  };

  const handleFileChange = async (event) => {
    try {
      const file = event.target.files[0];
      //console.log(file);

      if (file) {
        parse(file, {
          header: true,
          complete: (result) => {
            updateStoreById(token, storeId, result.data);
            inputFileRef.current.value = null;
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
            inputFileRef.current.value = null;
          },
        });
      }
    } catch (error) {
      console.error("Error in handleFileChange:", error);
    }
  };

  return (
    <div style={{ height: "90%", width: "90%", paddingTop: "10px" }}>
      <div height={"10%"} className="actions">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle style={styles.dialoginf} id="alert-dialog-title">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-alert-circle-filled"
              width="64"
              height="64"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#ff2825"
              fill="#00205b"
              stroke-linecap="round"
              stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"
                stroke-width="0"
                fill="#00205b"
              />
            </svg>
            <br />
            No olvides que solo puedes cargar tu inventario los días lunes de
            las 07:00:00 - 22:00:00 hrs.
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              style={styles.dialoginf}
              id="alert-dialog-description">
              De lo contrario la carga no estará disponible.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Ok</Button>
          </DialogActions>
        </Dialog>
        <IconButton onClick={handleClickOpen} sx={{ padding: 0 }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon icon-tabler icon-tabler-info-circle"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="#00205b"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 9h.01" />
            <path d="M11 12h1v4h1" />
          </svg>
        </IconButton>

        <div className="pz-center">
          <TextField
            placeholder="Buscar"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearch}
            fullWidth
            InputLabelProps={{
              shrink: false,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-filter-search"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="gray"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M11.36 20.213l-2.36 .787v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414" />
                    <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                    <path d="M20.2 20.2l1.8 1.8" />
                  </svg>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={<FileDownloadIcon />}
          onClick={handleStores}
          // disabled={loadingStores || blockEditByRol()}
          // disabled={!isButtonEnabledAux || loadingStores} ////==>este
          title="Descargar"
          sx={{
            "& .MuiButton-startIcon": {
              marginRight: "4px",
              marginLeft: "0px",
            },
          }}>
          {!isSmallScreen && "Descargar"}
        </Button>

        <Button
          component="label"
          variant="outlined"
          size="small"
          title="Subir Archivo"
          style={{ marginLeft: "10px" }}
          startIcon={<UploadFileIcon />}
          // disabled={!isButtonEnabledAux || loadingStores} ////==>este
          sx={{
            "& .MuiButton-startIcon": {
              marginRight: "4px",
              marginLeft: "0px",
            },
          }}>
          {!isSmallScreen && "Subir Archivo"}
          <input
            type="file"
            accept=".csv"
            ref={inputFileRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </Button>
        <Button
                          size="small"
                          component="label"
                          variant="outlined"
                          title="Ver Inventario"
                          onClick={() => navigate(`/stockTienda2`)}
                          startIcon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-clipboard-list"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M9 12l.01 0" /><path d="M13 12l2 0" /><path d="M9 16l.01 0" /><path d="M13 16l2 0" /></svg>}
                          
                          sx={{
                            "& .MuiButton-startIcon": {
                              marginRight: "4px",
                              marginLeft: "0px",
                            },
                          }}>
                         Ver Inventario
                          
                        </Button>

        <div className="pz-center">
          {loadingStores && <LinearWithValueLabel loading={loadingStores} />}
        </div>
      </div>

      <TableContainer
        sx={{
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ABABAB",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#888",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
          },
          "& .MuiTableCell-root": {
            fontSize: {
              xs: "8px",
              sm: "12px",
              md: "14px",
            },
          },
        }}
        style={styles.containerTable2}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">SUBCATEGORÍA</StyledTableCell>
              <StyledTableCell align="center">DESCRIPCIÓN</StyledTableCell>
              <StyledTableCell align="center">ID SUBCATEGORÍA</StyledTableCell>
              <StyledTableCell align="center">MATERIAL</StyledTableCell>
              <StyledTableCell align="center">STOCK</StyledTableCell>
              <StyledTableCell align="center">EDITAR</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsToDisplay.map((row, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell align="center">
                  {row.subCategoryName}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.description}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.subCategory}
                </StyledTableCell>
                <StyledTableCell align="center">{row.material}</StyledTableCell>
                <StyledTableCell align="center">{row.stock}</StyledTableCell>
                <StyledTableCell align="center">
                  {selectedRowIndex === index ? (
                    <SaveIcon />
                  ) : (
                    <IconButton
                      // disabled={!isButtonEnabledAux || loadingStores} ////==>este
                      color="primary"
                      onClick={() => handleStockEdit(index)}>
                      <EditIcon />
                    </IconButton>
                  )}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Card>
        <TablePagination
          component="div"
          sx={{
            display: "flex",
            justifyContent: "flex-start",
          }}
          count={filteredRows.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Productos por página:"
          rowsPerPageOptions={[10, 20, 50]}
        />
      </Card>
      <Dialog open={openDialog} onClose={handdleOnCloseModal}>
        <DialogTitle align="center" style={{ fontWeight: "bold" }}>
          Editar Stock
        </DialogTitle>
        <DialogContent>
          {rowsToDisplay[selectedRowIndex] !== undefined ? (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  SUBCATEGORÍA:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].subCategoryName}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  DESCRIPCIÓN:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].description}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  ID SUBCATEGORÍA:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].subCategory}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  MATERIAL:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].material}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  STOCK:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Stock"
                  variant="outlined"
                  required
                  value={modifiedStock}
                  error={error}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleStockInputChange}
                  size="small"
                />
              </Grid>
            </Grid>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handdleOnCloseModal()}
            color="secondary"
            startIcon={<CloseIcon />}>
            Cancelar
          </Button>
          <Button
            onClick={handleStockSave}
            color="primary"
            startIcon={<SaveIcon />}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stores: state.stores.stores,
    loading: state.stores.loading,
    token: state.users.uid,
    storeId: state.users.idNumber,
    loadingStores: state.stores.loading,
  };
};

const mapDispatchToProps = {
  updateStockStores: StoresCreators.updateStockStores,
  updateStoreById: StoresCreators.updateStoreById,
  downloadInventoryByStore: StoresCreators.downloadInventoryByStore,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableForm);
